import styled from "@emotion/styled";

export const PostExcerpt = styled("div")`
    ${({ theme }) => theme.text.paragraph.big}
    font-weight: 500;
    color: ${({ theme }) => theme.colors.primary.gunmetal["800"]};
    border-top: 1px solid ${({ theme }) => theme.colors.primary.gunmetal["160"]};
    padding-top: 24px;
`;
